module.exports = __webpack_public_path__ + "img/check.10a5b071.svg";